import { render } from "./CardRecom.vue?vue&type=template&id=5e5fcd18&scoped=true"
import script from "./CardRecom.vue?vue&type=script&lang=js"
export * from "./CardRecom.vue?vue&type=script&lang=js"

import "../assets/css/CardRecom.css?vue&type=style&index=0&id=5e5fcd18&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5fcd18"]])

export default __exports__